import React from "react";
//#region redux
//#endregion
//#region types
import { SelectInputProps, ToggleProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { CustomerConstants, IconDefinitionConstants } from "utils/constants";
import { DisplaySettingsSectionProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { HorizontalFormField, GroupSection, SelectInput, Toggle } from "components/common/wintForms";
//#endregion
import { LanguageHelper, LocalizationHelperInstance } from "utils/helpers";

const DisplaySettingsSection: React.FC<DisplaySettingsSectionProps> = ({ connect }) => {
  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.DisplaySettings)}
      icon={IconDefinitionConstants.WEye}
      navKey={CustomerConstants.SettingsNavKeys.Display}
    >
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("displaySettings.language")}
        label={TranslationKeys.Common.Language}
        items={LanguageHelper.getLanguageSelectionList()}
      />
      <HorizontalFormField<ToggleProps>
        Component={Toggle}
        {...connect("displaySettings.showCurrencyCode")}
        label={TranslationKeys.Invoice.ShowCurrencyCode}
        descriptionText={TranslationKeys.Invoice.ShowCurrencyCodeHelpText}
      />
    </GroupSection>
  );
};

export default DisplaySettingsSection;
